<template>
  <div class="container timeline-wrapper">
    <vue-slider
      :show="show"
      ref="timelineSlider"
      :disabled="!this.$auth.authenticated"
      @click.native="dateChange($event)"
      @drag-end="dateChange($event)"
      :value="readableDate(currentDate)"
      v-bind="options">
    </vue-slider>
    <div style="position: fixed; top: 30px;" v-if="!this.$auth.authenticated">Please <router-link :to="{ name: 'login' }">Login</router-link> to use this feature</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueSlider from 'vue-slider-component'

const props = {
  chamber: {
    type: String,
    required: false
  },
  show: {
    type: Boolean,
    required: true
  }
}

const components = {
  VueSlider
}

const computed = {
  ...mapGetters({
    currentDate: 'aggregateModels/currentDate',
    mainDates: 'aggregateModels/mainDates',
    mobile: 'ux/mobile'
  })
}

const methods = {
  ...mapActions({
    setCurrentDate: 'aggregateModels/setCurrentDate',
    setHouseDate: 'aggregateModels/setHouseDate',
    setSenateDate: 'aggregateModels/setSenateDate'
  }),
  readableDate (date) {
    if (!date) return ''
    const split = date.split('-')
    const year = split[0].slice(-2)
    const newDate = split[1] + '/' + split[2] + '/' + year
    return newDate
  },
  dateChange (date) {
    let newDate = null
    if (this.$auth.authenticated && date.currentIndex) {
      newDate = this.allDates[date.currentIndex].value
      this.setCurrentDate(newDate)
    } else {
      newDate = this.allDates[this.$refs.timelineSlider.currentIndex].value
      this.setCurrentDate(newDate)
    }

    if (this.chamber === 'house') {
      this.setHouseDate(newDate)
    } else if (this.chamber === 'senate') {
      this.setSenateDate(newDate)
    } else {
      this.setHouseDate(newDate)
      this.setSenateDate(newDate)
    }
  },
  refreshNav () {
    this.$nextTick(() => this.$refs.timelineSlider.refresh())
  }
}

export default {
  props,
  components,
  computed,
  methods,
  data () {
    return {
      allDates: [],
      options: {
        data: null,
        width: '100%',
        height: 4,
        dotSize: 16,
        show: true,
        tooltip: 'always',
        piecewise: true,
        piecewiseLabel: true,
        piecewiseStyle: {
          'backgroundColor': '#BDBDBD',
          'border': '1px solid #f5f5f5',
          'visibility': 'visible',
          'width': '8px',
          'height': '8px'
        },
        piecewiseActiveStyle: {
          'backgroundColor': '#FA3138',
          'border': '1.5px solid #f5f5f5',
          'width': '10px',
          'height': '10px'
        },
        processStyle: {
          'background-color': '#9E9E9E'
        },
        labelActiveStyle: {
          'color': '#666'
        },
        tooltipStyle: {
          'color': 'white',
          'font-size': '16px',
          'padding': '8px 12px',
          'backgroundColor': '#FA3138',
          'border': '0px solid #FA3138'
        },
        sliderStyle: {
          'backgroundColor': 'rgba(0, 0, 0, 0)',
          'border': '2px solid #FA3138',
          'animation': 'pulse 2s linear 1s infinite'
        }
      }
    }
  },
  beforeMount () {
    this.mainDates.forEach(date => {
      this.allDates.push({ label: this.readableDate(date), value: date })
    })
    this.options.data = this.allDates.map(item => item.label)
  },
  mounted () {
    window.addEventListener('scroll', this.refreshNav)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.refreshNav)
  }
}
</script>

<style>
.timeline-wrapper {
  position: fixed;
  top: 65px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100px;
  z-index: 500;
  padding: 1rem 6rem;
  display: flex;
  align-items: flex-end;
}

.vue-slider-tooltip {
  box-shadow: 0 6px 10px 0 rgba(0,0,0,0.4);
}

.vue-slider-component.vue-slider-horizontal-reverse .vue-slider-piecewise-label, .vue-slider-component.vue-slider-horizontal .vue-slider-piecewise-label {
  color: #C1C1C0 !important;
  font-size: 16px !important;
  top: -54px !important;
  font-weight: 500;
}

.vue-slider-component .vue-slider-tooltip {
  border-radius: 0px;
}

.vue-slider-piecewise-label {
  display: none !important;
}

.vue-slider-component.vue-slider-has-label {
  margin-bottom: 2px;
}

@keyframes pulse {
  0% { box-shadow: 0 0 8px rgba(250, 49, 56, 0.5), inset 0 0 8px rgba(250, 49, 56, 0.5); }
  50% { box-shadow: 0 0 16px rgba(250, 49, 56, 1), inset 0 0 14px rgba(250, 49, 56, 1); }
  100% { box-shadow: 0 0 8px rgba(250, 49, 56, 0.5), inset 0 0 8px rgba(250, 49, 56, 0.5); }
}
</style>



// WEBPACK FOOTER //
// src/components/common/TimelineSlider.vue